<h2 mat-dialog-title>Histórico da Comissão Julgadora</h2>
<mat-dialog-content>
  <div *ngIf="loading" class="historico-loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div *ngIf="!loading && historico.length === 0" class="historico-empty">
    Nenhum membro foi removido ou substituído nesta comissão.
  </div>

  <table mat-table [dataSource]="historico" *ngIf="!loading && historico.length > 0" class="historico-table">
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef>Nome</th>
      <td mat-cell *matCellDef="let row">{{ row.nome }}</td>
    </ng-container>

    <ng-container matColumnDef="papelOriginal">
      <th mat-header-cell *matHeaderCellDef>Papel original</th>
      <td mat-cell *matCellDef="let row">{{ getPapel(row.papelOriginal) }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let row">{{ getStatus(row.status) }}</td>
    </ng-container>

    <ng-container matColumnDef="motivoRemocao">
      <th mat-header-cell *matHeaderCellDef>Motivo</th>
      <td mat-cell *matCellDef="let row">{{ row.motivoRemocao || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="removidoEm">
      <th mat-header-cell *matHeaderCellDef>Data</th>
      <td mat-cell *matCellDef="let row">{{ row.removidoEm ? (row.removidoEm | date:'dd/MM/yyyy HH:mm') : '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="removidoPor">
      <th mat-header-cell *matHeaderCellDef>Responsável</th>
      <td mat-cell *matCellDef="let row">{{ row.removidoPor || '—' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['nome', 'papelOriginal', 'status', 'motivoRemocao', 'removidoEm', 'removidoPor']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['nome', 'papelOriginal', 'status', 'motivoRemocao', 'removidoEm', 'removidoPor']"></tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="fechar()">Fechar</button>
</mat-dialog-actions>
